var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"creditworthiness-calculation-wrapper"},[_c('div',{staticClass:"header"},[_vm._v("Twoja zdolność kredytowa:")]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("addSeparator")(_vm.cw_value))+" zł")])])}
var staticRenderFns = []

export { render, staticRenderFns }